export default __webpack_public_path__ + "static/media/interlagos-svg.8a9d24f3.svg";